export enum EGoogleTagEvents {
  RatingPagePlayersClick = 'Rating-page-players-click',
  RatingPageParentsClick = 'Rating-page-parents-click',
  RatingPageAcademiesClick = 'Rating-page-academies-click',
  RatingPageOpenPlayerClick = 'Rating-page-open-player-click',
  RatingPageAskQuestionClick = 'Rating-page-ask-question-click',
  PlayerRatingPageBackToRating = 'Player-rating-page-back-to-rating'
}
